var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongSuoGuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5a.5.5 0 001 0h-1zm6 0a.5.5 0 001 0h-1zm-5 0V5.056h-1V6.5h1zm0-1.444C5.5 3.636 6.628 2.5 8 2.5v-1c-1.942 0-3.5 1.6-3.5 3.556h1zM8 2.5c1.372 0 2.5 1.135 2.5 2.556h1C11.5 3.1 9.942 1.5 8 1.5v1zm2.5 2.556V6.5h1V5.056h-1zM8.5 9a.5.5 0 00-1 0h1zm-1 2a.5.5 0 001 0h-1zm0-2v2h1V9h-1z",
    fill: "#3F465C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 10,
    height: 7,
    rx: 0.5,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_suo_guan.7ebf848b.svg";
export { SvgTongyongSuoGuan as ReactComponent };